import * as XLSX from "xlsx";

export const EXHIBITOR_UPDATE_COLUMNS = [
  "Exhibitor ID",
  "Hall Number",
  "Stand Number",
  "Space Type",
  "Exhibit Arrival",
  "Material Arrival",
  "Dismantling",
  "Stand Size",
  "Product Categories",
];

export function buildExhibitorUpdateTemplate() {
  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.aoa_to_sheet([
    EXHIBITOR_UPDATE_COLUMNS,
    ["YOUR_EXHIBITOR_ID", "Hall 1A", "A1011", "Raw Space", "", "", "", 30, "A23.01, A01.01"],
    ["YOUR_EXHIBITOR_ID_2", "", "", "", "", "", "", "", "A23.01"],
  ]);
  sheet["!cols"] = EXHIBITOR_UPDATE_COLUMNS.map((column) => ({
    wch: column === "Product Categories" ? 32 : column === "Exhibitor ID" ? 26 : 20,
  }));
  XLSX.utils.book_append_sheet(workbook, sheet, "Exhibitor Data");

  const instructions = XLSX.utils.aoa_to_sheet([
    ["Field", "Instructions"],
    ["Exhibitor ID", "Replace the sample IDs with existing exhibitor IDs. Delete sample rows before adding your own data."],
    ["Optional fields", "Only fill fields you want to change. Blank cells leave existing values unchanged. You may remove unused columns."],
    ["Product Categories", "Enter comma-separated product codes, for example A23.01, A01.01. Use codes configured for your event."],
    ["Replacing categories", "A filled Product Categories cell replaces the exhibitor's entire category selection. Include every code you want to keep."],
    ["Blank categories", "Leave Product Categories blank to keep existing categories. A blank cell does not clear them."],
    ["Dates", "Use Excel date cells for Exhibit Arrival, Material Arrival and Dismantling."],
    ["Upload", "Keep Exhibitor Data as the first worksheet. Each row needs an Exhibitor ID and at least one field to update."],
  ]);
  instructions["!cols"] = [{ wch: 24 }, { wch: 125 }];
  XLSX.utils.book_append_sheet(workbook, instructions, "Instructions");
  return workbook;
}

export function parseExhibitorUpdateSheet(sheet) {
  const [rawHeaders = [], ...rows] = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    defval: "",
  });
  const headers = rawHeaders.map((header) => {
    const trimmed = String(header).trim();
    return EXHIBITOR_UPDATE_COLUMNS.find(
      (column) => column.toLowerCase() === trimmed.toLowerCase()
    ) || trimmed;
  });
  if (!headers.includes("Exhibitor ID")) {
    throw new Error("The first worksheet must include an Exhibitor ID column.");
  }

  return rows
    .filter((row) => row.some((value) => value !== null && value !== undefined && String(value).trim() !== ""))
    .map((row) => {
      const item = {};
      headers.forEach((header, index) => {
        if (header) item[header] = row[index] ?? "";
      });
      ["Exhibit Arrival", "Material Arrival", "Dismantling"].forEach((field) => {
        if (typeof item[field] === "number") {
          item[field] = new Date((item[field] - 25569) * 86400000);
        }
      });
      if (item["Stand Size"] !== undefined && String(item["Stand Size"]).trim() !== "") {
        item["Stand Size"] = Number(item["Stand Size"]);
      }
      if (item["Product Categories"] !== undefined) {
        item["Product Categories"] = String(item["Product Categories"] ?? "").trim();
      }
      return item;
    });
}
